// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeLanding_landing__tgean {
  --canvas: #f9f9f9;
  --card: #ffffff;
  --brand-orange: #ff5c09;
  --text: #0a0a0a;
  --border: #e5e5e5;
  background: var(--canvas);
  color: var(--text);
  min-height: 100vh;
}

/* ── Navigation ── */
.HomeLanding_nav__GA\\+Ny {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--card);
  border-bottom: 1px solid transparent;
  transition:
    background 0.25s ease,
    border-color 0.25s ease,
    box-shadow 0.25s ease;
}

.HomeLanding_navScrolled__d9It0 {
  background: rgba(255, 255, 255, 0.96);
  border-bottom-color: var(--border);
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.HomeLanding_navInner__MxwnF {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.85rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  flex-wrap: wrap;
}

.HomeLanding_navCenter__gB0Bc {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.HomeLanding_navActions__D-5Xo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
}

.HomeLanding_logoLink__1EOrJ {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.HomeLanding_logo__n61tY {
  height: 44px;
  width: auto;
  display: block;
}

.HomeLanding_navLinks__J1NPw {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.25rem 1.25rem;
}

.HomeLanding_navLink__TIp5F {
  color: var(--text);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.35rem 0;
  border-bottom: 2px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease;
}

.HomeLanding_navLink__TIp5F:hover {
  color: var(--brand-orange);
  border-bottom-color: var(--brand-orange);
}

.HomeLanding_navLinkActive__L-Z2W {
  color: var(--brand-orange);
  border-bottom-color: var(--brand-orange);
}

.HomeLanding_loginLink__V-Jcs {
  color: var(--text);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.5rem 0.75rem;
  transition: color 0.2s ease;
}

.HomeLanding_loginLink__V-Jcs:hover {
  color: var(--brand-orange);
}

.HomeLanding_getStartedBtn__GrJJT {
  background: var(--text, #0a0a0a);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 0.55rem 1.1rem;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.15s ease;
}

.HomeLanding_getStartedBtn__GrJJT:hover {
  background: #222;
  color: #ffffff;
  transform: translateY(-1px);
}

.HomeLanding_employerLoginBtn__WIHSt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0a0a0a;
  color: #ffffff !important;
  border: none;
  border-radius: 8px;
  padding: 0.55rem 1.1rem;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition:
    box-shadow 0.25s ease,
    transform 0.15s ease;
}

.HomeLanding_employerLoginBtn__WIHSt:hover {
  color: #ffffff !important;
  background: #0a0a0a;
  box-shadow:
    0 0 0 1px rgba(255, 92, 9, 0.4),
    0 0 20px rgba(255, 92, 9, 0.35);
  transform: translateY(-1px);
}

.HomeLanding_employerLoginBtn__WIHSt:active {
  transform: translateY(0);
  box-shadow:
    0 0 0 1px rgba(255, 92, 9, 0.3),
    0 0 12px rgba(255, 92, 9, 0.25);
}

.HomeLanding_menuToggle__srokT {
  display: none;
  background: none;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 0.4rem 0.55rem;
  cursor: pointer;
  color: var(--text);
  position: relative;
  z-index: 1003;
}

.HomeLanding_mobileMenuOverlay__ZLehi,
.HomeLanding_mobileMenuBackdrop__nD\\+Yt,
.HomeLanding_mobileMenuCard__Zqboo {
  display: none;
}

.HomeLanding_navMenuOpen__XBgIf {
  z-index: 1000;
}

/* ── Hero ── */
.HomeLanding_hero__5ZFFf {
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 1.25rem 3.5rem;
  text-align: center;
}

.HomeLanding_heroTitle__kVLRr {
  font-size: clamp(1.75rem, 4vw, 2.75rem);
  font-weight: 800;
  line-height: 1.15;
  margin: 0 0 1rem;
  color: var(--text);
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.HomeLanding_heroTagline__eyyjF {
  max-width: 760px;
  margin: 0 auto 2.5rem;
  font-size: clamp(0.95rem, 2vw, 1.05rem);
  line-height: 1.65;
  color: #444;
}

.HomeLanding_gatewayGrid__Z0b4c {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;
  text-align: left;
}

.HomeLanding_gatewayCard__xkyFz {
  border-radius: 16px;
  padding: 2rem;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.HomeLanding_gatewayCardDark__AiASJ {
  background: var(--text);
  color: #ffffff;
}

.HomeLanding_gatewayCardLight__TtWRC {
  background: var(--card);
  color: var(--text);
  border: 1px solid var(--border);
}

.HomeLanding_gatewayCardLight__TtWRC:hover {
  border-color: var(--brand-orange);
  box-shadow: 0 8px 24px rgba(255, 92, 9, 0.08);
}

.HomeLanding_gatewayCardDark__AiASJ:hover {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
}

.HomeLanding_gatewayTitle__vrHm\\+ {
  font-size: 1.35rem;
  font-weight: 700;
  margin: 0 0 1.25rem;
}

.HomeLanding_gatewayList__f9iEl {
  list-style: none;
  padding: 0;
  margin: 0 0 auto;
}

.HomeLanding_gatewayList__f9iEl li {
  position: relative;
  padding-left: 1.35rem;
  margin-bottom: 0.65rem;
  font-size: 0.95rem;
  line-height: 1.5;
}

.HomeLanding_gatewayList__f9iEl li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: var(--brand-orange);
  font-weight: 700;
}

.HomeLanding_btnPrimary__NJo0R {
  display: inline-block;
  width: 100%;
  margin-top: 1.5rem;
  padding: 0.85rem 1.25rem;
  background: var(--brand-orange);
  color: #ffffff !important;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.15s ease;
}

.HomeLanding_btnPrimary__NJo0R:hover {
  background: #e54f08;
  color: #ffffff !important;
  transform: translateY(-1px);
}

.HomeLanding_btnGhost__G5Fc8 {
  display: inline-block;
  width: 100%;
  margin-top: 1.5rem;
  padding: 0.85rem 1.25rem;
  background: transparent;
  color: var(--text) !important;
  border: 1px solid var(--text);
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, transform 0.15s ease;
}

.HomeLanding_btnGhost__G5Fc8:hover {
  border-color: var(--brand-orange);
  color: var(--brand-orange) !important;
  transform: translateY(-1px);
}

/* ── Job seeker banners ── */
.HomeLanding_jobBannersSection__fTUl4 {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.25rem 3.5rem;
}

.HomeLanding_jobBannersGrid__kE1zF {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;
}

.HomeLanding_jobBanner__M2Yrc {
  border-radius: 16px;
  padding: 1.75rem 1.65rem;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  transition: box-shadow 0.25s ease, transform 0.2s ease;
}

.HomeLanding_jobBanner__M2Yrc:hover {
  transform: translateY(-2px);
}

.HomeLanding_jobBannerBlue__AaFNO {
  background: linear-gradient(145deg, #eff6ff 0%, #ffffff 55%);
  border: 1px solid #bfdbfe;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
}

.HomeLanding_jobBannerBlue__AaFNO:hover {
  box-shadow: 0 12px 28px rgba(37, 99, 235, 0.12);
}

.HomeLanding_jobBannerOrange__wZ7uf {
  background: linear-gradient(145deg, #fff7ed 0%, #ffffff 55%);
  border: 1px solid #fed7aa;
  box-shadow: 0 8px 24px rgba(255, 92, 9, 0.08);
}

.HomeLanding_jobBannerOrange__wZ7uf:hover {
  box-shadow: 0 12px 28px rgba(255, 92, 9, 0.12);
}

.HomeLanding_jobBannerEyebrow__FELpa {
  margin: 0 0 0.65rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.HomeLanding_jobBannerBlue__AaFNO .HomeLanding_jobBannerEyebrow__FELpa {
  color: #1d4ed8;
}

.HomeLanding_jobBannerOrange__wZ7uf .HomeLanding_jobBannerEyebrow__FELpa {
  color: #c45500;
}

.HomeLanding_jobBannerTitle__bR\\+b8 {
  margin: 0 0 0.75rem;
  font-size: clamp(1.15rem, 2.2vw, 1.45rem);
  font-weight: 800;
  line-height: 1.25;
  color: var(--text);
}

.HomeLanding_jobBannerSubtitle__kkyx5 {
  margin: 0 0 1.35rem;
  font-size: 0.92rem;
  line-height: 1.6;
  color: #444;
  flex: 1 1;
}

.HomeLanding_jobBannerBtnBlue__NJzQD,
.HomeLanding_jobBannerBtnOrange__QbyWZ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  padding: 0.72rem 1.15rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.15s ease;
}

.HomeLanding_jobBannerBtnBlue__NJzQD {
  background: #2563eb;
  color: #ffffff !important;
}

.HomeLanding_jobBannerBtnBlue__NJzQD:hover {
  background: #1d4ed8;
  color: #ffffff !important;
  transform: translateY(-1px);
}

.HomeLanding_jobBannerBtnOrange__QbyWZ {
  background: var(--brand-orange);
  color: #ffffff !important;
}

.HomeLanding_jobBannerBtnOrange__QbyWZ:hover {
  background: #e54f08;
  color: #ffffff !important;
  transform: translateY(-1px);
}

/* ── Marketplace snapshot ── */
.HomeLanding_snapshotSection__RcakG {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 1.25rem 4.5rem;
}

.HomeLanding_snapshotGrid__VAne5 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;
}

.HomeLanding_snapshotCard__ShVwc {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.5rem;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.HomeLanding_snapshotCard__ShVwc:hover {
  border-color: var(--brand-orange);
  box-shadow: 0 8px 24px rgba(255, 92, 9, 0.06);
}

.HomeLanding_snapshotTitle__f8wbd {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
  color: var(--text);
}

.HomeLanding_snapshotSectionHead__wK2VU {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin: 0 0 1.25rem;
}

.HomeLanding_snapshotViewAll__hupfj {
  flex-shrink: 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--brand-orange);
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s ease, opacity 0.2s ease;
}

.HomeLanding_snapshotViewAll__hupfj:hover {
  color: #e54f08;
  opacity: 0.9;
}

.HomeLanding_snapshotTitleLink__6ZtcB {
  display: inline-block;
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 1.35rem;
  color: var(--text);
  text-decoration: none;
  line-height: 1.35;
  transition: color 0.2s ease;
}

.HomeLanding_snapshotTitleLink__6ZtcB:hover {
  color: var(--brand-orange);
}

.HomeLanding_snapshotList__flRBZ {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.HomeLanding_snapshotItem__u5h8g {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  min-height: 128px;
  padding: 1.05rem 1.15rem;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #fafafa;
  text-decoration: none;
  color: inherit;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.HomeLanding_snapshotItem__u5h8g:hover {
  border-color: var(--brand-orange);
  box-shadow: 0 4px 14px rgba(255, 92, 9, 0.06);
  background: #fff;
}

.HomeLanding_snapshotItem__u5h8g:hover .HomeLanding_snapshotAction__BnXcZ {
  color: var(--brand-orange);
}

.HomeLanding_snapshotAvatar__5JNWQ {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: #f3f3f3;
  border: 2px solid #f0f0f0;
}

.HomeLanding_snapshotBody__ZbhV3 {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.HomeLanding_snapshotHeader__a3vxQ {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.65rem;
}

.HomeLanding_snapshotHeaderActions__BlisD {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem;
  flex-shrink: 0;
}

.HomeLanding_snapshotAction__BnXcZ {
  font-size: 0.72rem;
  font-weight: 700;
  color: #576f76;
  white-space: nowrap;
  transition: color 0.2s ease;
}

.HomeLanding_snapshotItemTitle__KPd6E {
  margin: 0;
  flex: 1 1;
  min-width: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text);
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.HomeLanding_snapshotMeta__rC58v {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.45;
  color: #666;
}

.HomeLanding_snapshotTags__moLBp {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  min-height: 1.35rem;
}

.HomeLanding_snapshotTagsSpacer__Rgo0d {
  min-height: 1.35rem;
}

.HomeLanding_snapshotDate__RPADw {
  margin: 0.15rem 0 0;
  min-height: 1rem;
  font-size: 0.72rem;
  color: #888;
}

.HomeLanding_snapshotAbout__BT42v {
  margin: 0.15rem 0 0;
  font-size: 0.78rem;
  line-height: 1.35;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.HomeLanding_livePill__exPGn {
  flex-shrink: 0;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  background: #ecfdf3;
  color: #15803d;
  white-space: nowrap;
  letter-spacing: 0.01em;
}

.HomeLanding_tagChip__MB3Ic {
  font-size: 0.72rem;
  padding: 0.22rem 0.55rem;
  border-radius: 999px;
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.HomeLanding_viewAllLink__uW2f- {
  display: inline-block;
  margin-top: 1rem;
  color: var(--brand-orange);
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.HomeLanding_viewAllLink__uW2f-:hover {
  opacity: 0.85;
  color: var(--brand-orange);
}

.HomeLanding_emptyState__4Tz0S {
  padding: 1.5rem;
  text-align: center;
  color: #888;
  font-size: 0.9rem;
  border: 1px dashed var(--border);
  border-radius: 10px;
}

/* ── Institute trust row ── */
.HomeLanding_instituteRow__EJb0A {
  max-width: 1200px;
  margin: 1rem auto 3.5rem;
  padding: 0 1.25rem;
}

.HomeLanding_instituteBox__2NNca {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1.75rem 2rem;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 12px;
  transition: border-color 0.25s ease;
}

.HomeLanding_instituteBox__2NNca:hover {
  border-color: var(--brand-orange);
}

.HomeLanding_instituteTitle__P5oQL {
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  color: var(--text);
}

.HomeLanding_instituteText__yfyni {
  margin: 0;
  font-size: 0.925rem;
  line-height: 1.6;
  color: #555;
  max-width: 720px;
}

.HomeLanding_instituteLink__Vn6hg {
  flex-shrink: 0;
  color: var(--brand-orange);
  font-weight: 600;
  font-size: 0.925rem;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.2s ease;
}

.HomeLanding_instituteLink__Vn6hg:hover {
  opacity: 0.85;
  color: var(--brand-orange);
}

/* ── Culinary Academy CTA (below testimonials) ── */
.HomeLanding_academySection__tW2Ne {
  max-width: 1200px;
  margin: 0 auto 3.5rem;
  padding: 0 1.25rem;
}

.HomeLanding_academyCard__fh09I {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: clamp(1.75rem, 4vw, 2.5rem) clamp(1.25rem, 4vw, 2.5rem);
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 14px;
  text-align: center;
}

.HomeLanding_academyText__a4T7t {
  margin: 0;
  max-width: 640px;
  font-size: clamp(0.92rem, 2.2vw, 1.05rem);
  line-height: 1.65;
  color: #555;
}

.HomeLanding_academyBtn__NZpoW {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: min(100%, 420px);
  min-height: 48px;
  padding: 0.85rem 2rem;
  border-radius: 10px;
  background: var(--brand-orange);
  color: #fff;
  font-size: clamp(0.92rem, 2vw, 1rem);
  font-weight: 700;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.15s ease;
}

.HomeLanding_academyBtn__NZpoW:hover {
  background: #e54f08;
  color: #fff;
  transform: translateY(-1px);
}

/* ── Metrics banner ── */
.HomeLanding_metricsSection__1kMRH {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.25rem 3.5rem;
}

.HomeLanding_metricsBanner__LzqDH {
  background: var(--text);
  border-radius: 16px;
  padding: 2.5rem 2rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2rem;
  text-align: center;
}

.HomeLanding_metricValue__yhsEy {
  font-size: clamp(1.35rem, 2.5vw, 1.75rem);
  font-weight: 800;
  color: var(--brand-orange);
  margin: 0 0 0.65rem;
  line-height: 1.2;
}

.HomeLanding_metricText__cztDn {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.55;
  color: #d4d4d4;
}

.HomeLanding_chatbotWrap__kT1dl {
  position: fixed;
  z-index: 9999;
  bottom: 50px;
  right: 30px;
}

@media (max-width: 640px) {
  .HomeLanding_chatbotWrap__kT1dl {
    bottom: 24px;
    right: 16px;
  }
}

@keyframes HomeLanding_mobileBackdropIn__lwsaJ {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes HomeLanding_mobilePanelIn__vuL4y {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes HomeLanding_mobileDrawerIn__RCCEH {
  from {
    opacity: 0;
    transform: translateX(-16px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* ── Responsive ── */
@media (max-width: 991px) {
  .HomeLanding_navCenter__gB0Bc,
  .HomeLanding_navActions__D-5Xo {
    display: none;
  }

  .HomeLanding_menuToggle__srokT {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
  }

  .HomeLanding_navInner__MxwnF {
    row-gap: 0;
  }

  .HomeLanding_mobileMenuOverlay__ZLehi {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    position: fixed;
    inset: 0;
    z-index: 1100;
    padding: 0;
    box-sizing: border-box;
  }

  .HomeLanding_mobileMenuBackdrop__nD\\+Yt {
    display: block;
    position: absolute;
    inset: 0;
    border: none;
    padding: 0;
    margin: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    cursor: pointer;
    animation: HomeLanding_mobileBackdropIn__lwsaJ 0.2s ease;
  }

  .HomeLanding_mobileMenuCard__Zqboo {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
    width: min(100%, 360px);
    max-width: 86vw;
    height: 100%;
    max-height: 100%;
    margin: 0;
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
    background: #f4f5f7;
    border-radius: 0 1rem 1rem 0;
    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.22);
    overflow: hidden;
    overflow-y: auto;
    animation: HomeLanding_mobileDrawerIn__RCCEH 0.22s ease;
  }

  .HomeLanding_mobileMenuWelcome__pON6O {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    margin: 0.75rem;
    padding: 1rem 1rem 1.15rem;
    background: #111111;
    border-radius: 1rem;
    color: #ffffff;
  }

  .HomeLanding_mobileMenuWelcomeTop__lkngV {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.65rem;
  }

  .HomeLanding_mobileMenuLogoLink__KcvOR {
    display: inline-flex;
    align-items: center;
    min-width: 0;
  }

  .HomeLanding_mobileMenuLogo__Y2V\\+t {
    height: 36px;
    width: auto;
    max-width: 160px;
    object-fit: contain;
  }

  .HomeLanding_mobileMenuClose__gfzX6 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    color: #ffffff;
    cursor: pointer;
  }

  .HomeLanding_mobileMenuWelcomeTitle__R623H {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 1.3;
    color: #ffffff;
    text-align: left;
  }

  .HomeLanding_mobileMenuWelcomeSub__IUM6\\+ {
    margin: 0 0 0.85rem;
    font-size: 0.84rem;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.72);
    text-align: left;
  }

  .HomeLanding_mobileMenuCtaRow__lYFxd {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.55rem;
  }

  .HomeLanding_mobileMenuNav__rdGtZ {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.55rem;
    padding: 0.15rem 0.75rem 1.25rem;
  }

  .HomeLanding_mobileMenuLink__JnR-e {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.75rem;
    width: 100%;
    padding: 0.9rem 0.95rem;
    color: #1a1a1b;
    text-decoration: none;
    text-align: left;
    font-size: 0.95rem;
    font-weight: 600;
    background: #ffffff;
    border: 1px solid #e8eaed;
    border-radius: 0.85rem;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  }

  .HomeLanding_mobileMenuLinkIcon__MaAgE {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 2rem;
    height: 2rem;
    border-radius: 0.55rem;
    background: #fff4ed;
    color: #ff5c09;
  }

  .HomeLanding_mobileMenuLinkLabel__mUxJ4 {
    flex: 1 1;
    min-width: 0;
    line-height: 1.3;
    text-align: left;
  }

  .HomeLanding_mobileMenuLinkChevron__\\+Seaa {
    flex-shrink: 0;
    color: #9aa3ab;
  }

  .HomeLanding_mobileMenuLink__JnR-e:hover,
  .HomeLanding_mobileMenuLinkActive__BhddF {
    background: #fff7f2;
    border-color: #ffd7bf;
    color: #ff5c09;
  }

  .HomeLanding_mobileMenuLogin__U10l3 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    width: 100%;
    margin-top: 0;
    padding: 0.8rem 0.75rem;
    color: #0a0a0a;
    text-decoration: none;
    font-size: 0.92rem;
    font-weight: 700;
    border: none;
    border-radius: 0.7rem;
    background: #fff4ed;
    transition: background 0.15s ease, color 0.15s ease;
  }

  .HomeLanding_mobileMenuLogin__U10l3:hover {
    border-color: transparent;
    color: #0a0a0a;
    background: #ffe8d9;
  }

  .HomeLanding_mobileMenuEmployerBtn__swfGV {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    width: 100%;
    margin-top: 0;
    padding: 0.8rem 0.75rem;
    background: #ff5c09;
    color: #ffffff !important;
    text-decoration: none;
    font-size: 0.92rem;
    font-weight: 700;
    border: none;
    border-radius: 0.7rem;
    cursor: pointer;
    transition: background 0.15s ease;
  }

  .HomeLanding_mobileMenuEmployerBtn__swfGV:hover {
    color: #ffffff !important;
    background: #e65308;
    box-shadow: none;
    transform: none;
  }

  .HomeLanding_gatewayGrid__Z0b4c,
  .HomeLanding_jobBannersGrid__kE1zF,
  .HomeLanding_snapshotGrid__VAne5,
  .HomeLanding_metricsBanner__LzqDH {
    grid-template-columns: 1fr;
  }

  .HomeLanding_jobBannersSection__fTUl4 {
    padding: 0 1rem 3rem;
  }

  .HomeLanding_jobBanner__M2Yrc {
    padding: 1.35rem 1.2rem;
  }

  .HomeLanding_jobBannerBtnBlue__NJzQD,
  .HomeLanding_jobBannerBtnOrange__QbyWZ {
    width: 100%;
    align-self: stretch;
  }

  .HomeLanding_snapshotSection__RcakG {
    padding: 0.75rem 1rem 3.5rem;
  }

  .HomeLanding_snapshotGrid__VAne5 {
    gap: 1.5rem;
  }

  .HomeLanding_snapshotCard__ShVwc {
    padding: 1.25rem;
    box-shadow: 0 4px 18px rgba(15, 23, 42, 0.04);
  }

  .HomeLanding_snapshotTitle__f8wbd,
  .HomeLanding_snapshotTitleLink__6ZtcB {
    font-size: 1.2rem;
  }

  .HomeLanding_snapshotSectionHead__wK2VU {
    margin-bottom: 1rem;
  }

  .HomeLanding_snapshotViewAll__hupfj {
    font-size: 0.85rem;
  }

  .HomeLanding_snapshotList__flRBZ {
    gap: 0.75rem;
  }

  .HomeLanding_snapshotItem__u5h8g {
    min-height: 0;
    padding: 1rem;
    gap: 0.85rem;
    border-left: 3px solid var(--brand-orange);
  }

  .HomeLanding_snapshotAvatar__5JNWQ {
    width: 52px;
    height: 52px;
  }

  .HomeLanding_snapshotItemTitle__KPd6E {
    font-size: 1.05rem;
    -webkit-line-clamp: 2;
  }

  .HomeLanding_snapshotMeta__rC58v {
    font-size: 0.875rem;
    color: #555;
    word-break: break-word;
  }

  .HomeLanding_snapshotBody__ZbhV3 {
    gap: 0.45rem;
  }

  .HomeLanding_snapshotTags__moLBp {
    gap: 0.45rem;
    min-height: 0;
  }

  .HomeLanding_tagChip__MB3Ic {
    font-size: 0.78rem;
    padding: 0.3rem 0.65rem;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }

  .HomeLanding_snapshotDate__RPADw {
    font-size: 0.8rem;
    min-height: 0;
  }

  .HomeLanding_snapshotAbout__BT42v {
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 0.82rem;
  }

  .HomeLanding_livePill__exPGn,
  .HomeLanding_snapshotAction__BnXcZ {
    font-size: 0.72rem;
  }

  .HomeLanding_livePill__exPGn {
    padding: 0.25rem 0.6rem;
  }

  .HomeLanding_viewAllLink__uW2f- {
    margin-top: 1.15rem;
    padding: 0.35rem 0;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
  }

  .HomeLanding_instituteBox__2NNca {
    flex-direction: column;
    align-items: flex-start;
  }

  .HomeLanding_academyCard__fh09I {
    gap: 1.25rem;
    padding: 1.5rem 1.15rem;
  }

  .HomeLanding_academyBtn__NZpoW {
    width: 100%;
    max-width: none;
    padding: 0.9rem 1.25rem;
  }
}

@media (max-width: 767px) {
  .HomeLanding_snapshotGrid__VAne5 {
    gap: 1.75rem;
  }

  .HomeLanding_snapshotHeader__a3vxQ {
    flex-wrap: wrap;
    align-items: center;
  }
}

@media (max-width: 575px) {
  .HomeLanding_hero__5ZFFf {
    padding-top: 2rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .HomeLanding_gatewayCard__xkyFz {
    padding: 1.35rem;
    min-height: auto;
  }

  .HomeLanding_snapshotSection__RcakG {
    padding: 0.75rem 0.85rem 3rem;
  }

  .HomeLanding_snapshotCard__ShVwc {
    padding: 1rem;
    border-radius: 14px;
  }

  .HomeLanding_snapshotTitle__f8wbd,
  .HomeLanding_snapshotTitleLink__6ZtcB {
    font-size: 1.15rem;
  }

  .HomeLanding_snapshotItem__u5h8g {
    padding: 0.95rem 0.9rem;
    border-radius: 10px;
  }

  .HomeLanding_snapshotAvatar__5JNWQ {
    width: 48px;
    height: 48px;
  }

  .HomeLanding_snapshotItemTitle__KPd6E {
    font-size: 1rem;
  }

  .HomeLanding_snapshotMeta__rC58v {
    font-size: 0.84rem;
  }

  .HomeLanding_tagChip__MB3Ic {
    font-size: 0.75rem;
    padding: 0.28rem 0.58rem;
  }

  .HomeLanding_metricsBanner__LzqDH {
    padding: 1.75rem 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/HomeLanding.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC;;;yBAGuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6CAA6C;EAC7C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB;;wBAEsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB;;mCAEiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB;;mCAEiC;AACnC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uCAAuC;EACvC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4DAA4D;EAC5D,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,4DAA4D;EAC5D,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAO;AACT;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,8EAA8E;AAChF;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA,oDAAoD;AACpD;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gEAAgE;EAChE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,2BAA2B;IAC3B,eAAe;IACf,QAAQ;IACR,aAAa;IACb,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,SAAS;IACT,8BAA8B;IAC9B,0BAA0B;IAC1B,kCAAkC;IAClC,eAAe;IACf,wDAAqC;EACvC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,4BAA4B;IAC5B,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,uDAAoC;EACtC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,oBAAoB;IACpB,qCAAqC;IACrC,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,4CAA4C;IAC5C,4EAA4E;EAC9E;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,mDAAmD;EACrD;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,aAAa;IACb,YAAY;IACZ,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".landing {\n  --canvas: #f9f9f9;\n  --card: #ffffff;\n  --brand-orange: #ff5c09;\n  --text: #0a0a0a;\n  --border: #e5e5e5;\n  background: var(--canvas);\n  color: var(--text);\n  min-height: 100vh;\n}\n\n/* ── Navigation ── */\n.nav {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: var(--card);\n  border-bottom: 1px solid transparent;\n  transition:\n    background 0.25s ease,\n    border-color 0.25s ease,\n    box-shadow 0.25s ease;\n}\n\n.navScrolled {\n  background: rgba(255, 255, 255, 0.96);\n  border-bottom-color: var(--border);\n  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.navInner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0.85rem 1.25rem;\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  flex-wrap: wrap;\n}\n\n.navCenter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.navActions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-left: auto;\n}\n\n.logoLink {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n}\n\n.logo {\n  height: 44px;\n  width: auto;\n  display: block;\n}\n\n.navLinks {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 0.25rem 1.25rem;\n}\n\n.navLink {\n  color: var(--text);\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  padding: 0.35rem 0;\n  border-bottom: 2px solid transparent;\n  transition: color 0.2s ease, border-color 0.2s ease;\n}\n\n.navLink:hover {\n  color: var(--brand-orange);\n  border-bottom-color: var(--brand-orange);\n}\n\n.navLinkActive {\n  color: var(--brand-orange);\n  border-bottom-color: var(--brand-orange);\n}\n\n.loginLink {\n  color: var(--text);\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  padding: 0.5rem 0.75rem;\n  transition: color 0.2s ease;\n}\n\n.loginLink:hover {\n  color: var(--brand-orange);\n}\n\n.getStartedBtn {\n  background: var(--text, #0a0a0a);\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  padding: 0.55rem 1.1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.15s ease;\n}\n\n.getStartedBtn:hover {\n  background: #222;\n  color: #ffffff;\n  transform: translateY(-1px);\n}\n\n.employerLoginBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #0a0a0a;\n  color: #ffffff !important;\n  border: none;\n  border-radius: 8px;\n  padding: 0.55rem 1.1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n  transition:\n    box-shadow 0.25s ease,\n    transform 0.15s ease;\n}\n\n.employerLoginBtn:hover {\n  color: #ffffff !important;\n  background: #0a0a0a;\n  box-shadow:\n    0 0 0 1px rgba(255, 92, 9, 0.4),\n    0 0 20px rgba(255, 92, 9, 0.35);\n  transform: translateY(-1px);\n}\n\n.employerLoginBtn:active {\n  transform: translateY(0);\n  box-shadow:\n    0 0 0 1px rgba(255, 92, 9, 0.3),\n    0 0 12px rgba(255, 92, 9, 0.25);\n}\n\n.menuToggle {\n  display: none;\n  background: none;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 0.4rem 0.55rem;\n  cursor: pointer;\n  color: var(--text);\n  position: relative;\n  z-index: 1003;\n}\n\n.mobileMenuOverlay,\n.mobileMenuBackdrop,\n.mobileMenuCard {\n  display: none;\n}\n\n.navMenuOpen {\n  z-index: 1000;\n}\n\n/* ── Hero ── */\n.hero {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 3rem 1.25rem 3.5rem;\n  text-align: center;\n}\n\n.heroTitle {\n  font-size: clamp(1.75rem, 4vw, 2.75rem);\n  font-weight: 800;\n  line-height: 1.15;\n  margin: 0 0 1rem;\n  color: var(--text);\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.heroTagline {\n  max-width: 760px;\n  margin: 0 auto 2.5rem;\n  font-size: clamp(0.95rem, 2vw, 1.05rem);\n  line-height: 1.65;\n  color: #444;\n}\n\n.gatewayGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.25rem;\n  text-align: left;\n}\n\n.gatewayCard {\n  border-radius: 16px;\n  padding: 2rem;\n  min-height: 320px;\n  display: flex;\n  flex-direction: column;\n  transition: border-color 0.25s ease, box-shadow 0.25s ease;\n}\n\n.gatewayCardDark {\n  background: var(--text);\n  color: #ffffff;\n}\n\n.gatewayCardLight {\n  background: var(--card);\n  color: var(--text);\n  border: 1px solid var(--border);\n}\n\n.gatewayCardLight:hover {\n  border-color: var(--brand-orange);\n  box-shadow: 0 8px 24px rgba(255, 92, 9, 0.08);\n}\n\n.gatewayCardDark:hover {\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);\n}\n\n.gatewayTitle {\n  font-size: 1.35rem;\n  font-weight: 700;\n  margin: 0 0 1.25rem;\n}\n\n.gatewayList {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 auto;\n}\n\n.gatewayList li {\n  position: relative;\n  padding-left: 1.35rem;\n  margin-bottom: 0.65rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.gatewayList li::before {\n  content: \"✓\";\n  position: absolute;\n  left: 0;\n  color: var(--brand-orange);\n  font-weight: 700;\n}\n\n.btnPrimary {\n  display: inline-block;\n  width: 100%;\n  margin-top: 1.5rem;\n  padding: 0.85rem 1.25rem;\n  background: var(--brand-orange);\n  color: #ffffff !important;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.15s ease;\n}\n\n.btnPrimary:hover {\n  background: #e54f08;\n  color: #ffffff !important;\n  transform: translateY(-1px);\n}\n\n.btnGhost {\n  display: inline-block;\n  width: 100%;\n  margin-top: 1.5rem;\n  padding: 0.85rem 1.25rem;\n  background: transparent;\n  color: var(--text) !important;\n  border: 1px solid var(--text);\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  transition: border-color 0.2s ease, color 0.2s ease, transform 0.15s ease;\n}\n\n.btnGhost:hover {\n  border-color: var(--brand-orange);\n  color: var(--brand-orange) !important;\n  transform: translateY(-1px);\n}\n\n/* ── Job seeker banners ── */\n.jobBannersSection {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.25rem 3.5rem;\n}\n\n.jobBannersGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.25rem;\n}\n\n.jobBanner {\n  border-radius: 16px;\n  padding: 1.75rem 1.65rem;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  transition: box-shadow 0.25s ease, transform 0.2s ease;\n}\n\n.jobBanner:hover {\n  transform: translateY(-2px);\n}\n\n.jobBannerBlue {\n  background: linear-gradient(145deg, #eff6ff 0%, #ffffff 55%);\n  border: 1px solid #bfdbfe;\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);\n}\n\n.jobBannerBlue:hover {\n  box-shadow: 0 12px 28px rgba(37, 99, 235, 0.12);\n}\n\n.jobBannerOrange {\n  background: linear-gradient(145deg, #fff7ed 0%, #ffffff 55%);\n  border: 1px solid #fed7aa;\n  box-shadow: 0 8px 24px rgba(255, 92, 9, 0.08);\n}\n\n.jobBannerOrange:hover {\n  box-shadow: 0 12px 28px rgba(255, 92, 9, 0.12);\n}\n\n.jobBannerEyebrow {\n  margin: 0 0 0.65rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.jobBannerBlue .jobBannerEyebrow {\n  color: #1d4ed8;\n}\n\n.jobBannerOrange .jobBannerEyebrow {\n  color: #c45500;\n}\n\n.jobBannerTitle {\n  margin: 0 0 0.75rem;\n  font-size: clamp(1.15rem, 2.2vw, 1.45rem);\n  font-weight: 800;\n  line-height: 1.25;\n  color: var(--text);\n}\n\n.jobBannerSubtitle {\n  margin: 0 0 1.35rem;\n  font-size: 0.92rem;\n  line-height: 1.6;\n  color: #444;\n  flex: 1;\n}\n\n.jobBannerBtnBlue,\n.jobBannerBtnOrange {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  align-self: flex-start;\n  padding: 0.72rem 1.15rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 700;\n  text-decoration: none;\n  transition: background 0.2s ease, transform 0.15s ease;\n}\n\n.jobBannerBtnBlue {\n  background: #2563eb;\n  color: #ffffff !important;\n}\n\n.jobBannerBtnBlue:hover {\n  background: #1d4ed8;\n  color: #ffffff !important;\n  transform: translateY(-1px);\n}\n\n.jobBannerBtnOrange {\n  background: var(--brand-orange);\n  color: #ffffff !important;\n}\n\n.jobBannerBtnOrange:hover {\n  background: #e54f08;\n  color: #ffffff !important;\n  transform: translateY(-1px);\n}\n\n/* ── Marketplace snapshot ── */\n.snapshotSection {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1rem 1.25rem 4.5rem;\n}\n\n.snapshotGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.25rem;\n}\n\n.snapshotCard {\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 1.5rem;\n  transition: border-color 0.25s ease, box-shadow 0.25s ease;\n}\n\n.snapshotCard:hover {\n  border-color: var(--brand-orange);\n  box-shadow: 0 8px 24px rgba(255, 92, 9, 0.06);\n}\n\n.snapshotTitle {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 0;\n  color: var(--text);\n}\n\n.snapshotSectionHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin: 0 0 1.25rem;\n}\n\n.snapshotViewAll {\n  flex-shrink: 0;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--brand-orange);\n  text-decoration: none;\n  white-space: nowrap;\n  transition: color 0.2s ease, opacity 0.2s ease;\n}\n\n.snapshotViewAll:hover {\n  color: #e54f08;\n  opacity: 0.9;\n}\n\n.snapshotTitleLink {\n  display: inline-block;\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 0 0 1.35rem;\n  color: var(--text);\n  text-decoration: none;\n  line-height: 1.35;\n  transition: color 0.2s ease;\n}\n\n.snapshotTitleLink:hover {\n  color: var(--brand-orange);\n}\n\n.snapshotList {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.snapshotItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  min-height: 128px;\n  padding: 1.05rem 1.15rem;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: #fafafa;\n  text-decoration: none;\n  color: inherit;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.snapshotItem:hover {\n  border-color: var(--brand-orange);\n  box-shadow: 0 4px 14px rgba(255, 92, 9, 0.06);\n  background: #fff;\n}\n\n.snapshotItem:hover .snapshotAction {\n  color: var(--brand-orange);\n}\n\n.snapshotAvatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  background: #f3f3f3;\n  border: 2px solid #f0f0f0;\n}\n\n.snapshotBody {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.snapshotHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.65rem;\n}\n\n.snapshotHeaderActions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.35rem;\n  flex-shrink: 0;\n}\n\n.snapshotAction {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #576f76;\n  white-space: nowrap;\n  transition: color 0.2s ease;\n}\n\n.snapshotItemTitle {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text);\n  line-height: 1.35;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.snapshotMeta {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  color: #666;\n}\n\n.snapshotTags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  min-height: 1.35rem;\n}\n\n.snapshotTagsSpacer {\n  min-height: 1.35rem;\n}\n\n.snapshotDate {\n  margin: 0.15rem 0 0;\n  min-height: 1rem;\n  font-size: 0.72rem;\n  color: #888;\n}\n\n.snapshotAbout {\n  margin: 0.15rem 0 0;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: #666;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.livePill {\n  flex-shrink: 0;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  background: #ecfdf3;\n  color: #15803d;\n  white-space: nowrap;\n  letter-spacing: 0.01em;\n}\n\n.tagChip {\n  font-size: 0.72rem;\n  padding: 0.22rem 0.55rem;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  white-space: nowrap;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.3;\n}\n\n.viewAllLink {\n  display: inline-block;\n  margin-top: 1rem;\n  color: var(--brand-orange);\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n}\n\n.viewAllLink:hover {\n  opacity: 0.85;\n  color: var(--brand-orange);\n}\n\n.emptyState {\n  padding: 1.5rem;\n  text-align: center;\n  color: #888;\n  font-size: 0.9rem;\n  border: 1px dashed var(--border);\n  border-radius: 10px;\n}\n\n/* ── Institute trust row ── */\n.instituteRow {\n  max-width: 1200px;\n  margin: 1rem auto 3.5rem;\n  padding: 0 1.25rem;\n}\n\n.instituteBox {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  padding: 1.75rem 2rem;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  transition: border-color 0.25s ease;\n}\n\n.instituteBox:hover {\n  border-color: var(--brand-orange);\n}\n\n.instituteTitle {\n  font-size: 1.15rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem;\n  color: var(--text);\n}\n\n.instituteText {\n  margin: 0;\n  font-size: 0.925rem;\n  line-height: 1.6;\n  color: #555;\n  max-width: 720px;\n}\n\n.instituteLink {\n  flex-shrink: 0;\n  color: var(--brand-orange);\n  font-weight: 600;\n  font-size: 0.925rem;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: opacity 0.2s ease;\n}\n\n.instituteLink:hover {\n  opacity: 0.85;\n  color: var(--brand-orange);\n}\n\n/* ── Culinary Academy CTA (below testimonials) ── */\n.academySection {\n  max-width: 1200px;\n  margin: 0 auto 3.5rem;\n  padding: 0 1.25rem;\n}\n\n.academyCard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n  padding: clamp(1.75rem, 4vw, 2.5rem) clamp(1.25rem, 4vw, 2.5rem);\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  text-align: center;\n}\n\n.academyText {\n  margin: 0;\n  max-width: 640px;\n  font-size: clamp(0.92rem, 2.2vw, 1.05rem);\n  line-height: 1.65;\n  color: #555;\n}\n\n.academyBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: min(100%, 420px);\n  min-height: 48px;\n  padding: 0.85rem 2rem;\n  border-radius: 10px;\n  background: var(--brand-orange);\n  color: #fff;\n  font-size: clamp(0.92rem, 2vw, 1rem);\n  font-weight: 700;\n  text-decoration: none;\n  transition: background 0.2s ease, transform 0.15s ease;\n}\n\n.academyBtn:hover {\n  background: #e54f08;\n  color: #fff;\n  transform: translateY(-1px);\n}\n\n/* ── Metrics banner ── */\n.metricsSection {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.25rem 3.5rem;\n}\n\n.metricsBanner {\n  background: var(--text);\n  border-radius: 16px;\n  padding: 2.5rem 2rem;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 2rem;\n  text-align: center;\n}\n\n.metricValue {\n  font-size: clamp(1.35rem, 2.5vw, 1.75rem);\n  font-weight: 800;\n  color: var(--brand-orange);\n  margin: 0 0 0.65rem;\n  line-height: 1.2;\n}\n\n.metricText {\n  margin: 0;\n  font-size: 0.875rem;\n  line-height: 1.55;\n  color: #d4d4d4;\n}\n\n.chatbotWrap {\n  position: fixed;\n  z-index: 9999;\n  bottom: 50px;\n  right: 30px;\n}\n\n@media (max-width: 640px) {\n  .chatbotWrap {\n    bottom: 24px;\n    right: 16px;\n  }\n}\n\n@keyframes mobileBackdropIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes mobilePanelIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes mobileDrawerIn {\n  from {\n    opacity: 0;\n    transform: translateX(-16px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* ── Responsive ── */\n@media (max-width: 991px) {\n  .navCenter,\n  .navActions {\n    display: none;\n  }\n\n  .menuToggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: auto;\n  }\n\n  .navInner {\n    row-gap: 0;\n  }\n\n  .mobileMenuOverlay {\n    display: flex;\n    align-items: stretch;\n    justify-content: flex-start;\n    position: fixed;\n    inset: 0;\n    z-index: 1100;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  .mobileMenuBackdrop {\n    display: block;\n    position: absolute;\n    inset: 0;\n    border: none;\n    padding: 0;\n    margin: 0;\n    background: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(6px);\n    -webkit-backdrop-filter: blur(6px);\n    cursor: pointer;\n    animation: mobileBackdropIn 0.2s ease;\n  }\n\n  .mobileMenuCard {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    z-index: 1;\n    width: min(100%, 360px);\n    max-width: 86vw;\n    height: 100%;\n    max-height: 100%;\n    margin: 0;\n    padding-top: env(safe-area-inset-top);\n    padding-bottom: env(safe-area-inset-bottom);\n    background: #f4f5f7;\n    border-radius: 0 1rem 1rem 0;\n    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.22);\n    overflow: hidden;\n    overflow-y: auto;\n    animation: mobileDrawerIn 0.22s ease;\n  }\n\n  .mobileMenuWelcome {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    margin: 0.75rem;\n    padding: 1rem 1rem 1.15rem;\n    background: #111111;\n    border-radius: 1rem;\n    color: #ffffff;\n  }\n\n  .mobileMenuWelcomeTop {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    margin-bottom: 0.65rem;\n  }\n\n  .mobileMenuLogoLink {\n    display: inline-flex;\n    align-items: center;\n    min-width: 0;\n  }\n\n  .mobileMenuLogo {\n    height: 36px;\n    width: auto;\n    max-width: 160px;\n    object-fit: contain;\n  }\n\n  .mobileMenuClose {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 36px;\n    height: 36px;\n    border: 1px solid rgba(255, 255, 255, 0.22);\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.08);\n    color: #ffffff;\n    cursor: pointer;\n  }\n\n  .mobileMenuWelcomeTitle {\n    margin: 0;\n    font-size: 1.15rem;\n    font-weight: 700;\n    line-height: 1.3;\n    color: #ffffff;\n    text-align: left;\n  }\n\n  .mobileMenuWelcomeSub {\n    margin: 0 0 0.85rem;\n    font-size: 0.84rem;\n    line-height: 1.4;\n    color: rgba(255, 255, 255, 0.72);\n    text-align: left;\n  }\n\n  .mobileMenuCtaRow {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.55rem;\n  }\n\n  .mobileMenuNav {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.55rem;\n    padding: 0.15rem 0.75rem 1.25rem;\n  }\n\n  .mobileMenuLink {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.75rem;\n    width: 100%;\n    padding: 0.9rem 0.95rem;\n    color: #1a1a1b;\n    text-decoration: none;\n    text-align: left;\n    font-size: 0.95rem;\n    font-weight: 600;\n    background: #ffffff;\n    border: 1px solid #e8eaed;\n    border-radius: 0.85rem;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  }\n\n  .mobileMenuLinkIcon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 2rem;\n    height: 2rem;\n    border-radius: 0.55rem;\n    background: #fff4ed;\n    color: #ff5c09;\n  }\n\n  .mobileMenuLinkLabel {\n    flex: 1;\n    min-width: 0;\n    line-height: 1.3;\n    text-align: left;\n  }\n\n  .mobileMenuLinkChevron {\n    flex-shrink: 0;\n    color: #9aa3ab;\n  }\n\n  .mobileMenuLink:hover,\n  .mobileMenuLinkActive {\n    background: #fff7f2;\n    border-color: #ffd7bf;\n    color: #ff5c09;\n  }\n\n  .mobileMenuLogin {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.4rem;\n    width: 100%;\n    margin-top: 0;\n    padding: 0.8rem 0.75rem;\n    color: #0a0a0a;\n    text-decoration: none;\n    font-size: 0.92rem;\n    font-weight: 700;\n    border: none;\n    border-radius: 0.7rem;\n    background: #fff4ed;\n    transition: background 0.15s ease, color 0.15s ease;\n  }\n\n  .mobileMenuLogin:hover {\n    border-color: transparent;\n    color: #0a0a0a;\n    background: #ffe8d9;\n  }\n\n  .mobileMenuEmployerBtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.4rem;\n    width: 100%;\n    margin-top: 0;\n    padding: 0.8rem 0.75rem;\n    background: #ff5c09;\n    color: #ffffff !important;\n    text-decoration: none;\n    font-size: 0.92rem;\n    font-weight: 700;\n    border: none;\n    border-radius: 0.7rem;\n    cursor: pointer;\n    transition: background 0.15s ease;\n  }\n\n  .mobileMenuEmployerBtn:hover {\n    color: #ffffff !important;\n    background: #e65308;\n    box-shadow: none;\n    transform: none;\n  }\n\n  .gatewayGrid,\n  .jobBannersGrid,\n  .snapshotGrid,\n  .metricsBanner {\n    grid-template-columns: 1fr;\n  }\n\n  .jobBannersSection {\n    padding: 0 1rem 3rem;\n  }\n\n  .jobBanner {\n    padding: 1.35rem 1.2rem;\n  }\n\n  .jobBannerBtnBlue,\n  .jobBannerBtnOrange {\n    width: 100%;\n    align-self: stretch;\n  }\n\n  .snapshotSection {\n    padding: 0.75rem 1rem 3.5rem;\n  }\n\n  .snapshotGrid {\n    gap: 1.5rem;\n  }\n\n  .snapshotCard {\n    padding: 1.25rem;\n    box-shadow: 0 4px 18px rgba(15, 23, 42, 0.04);\n  }\n\n  .snapshotTitle,\n  .snapshotTitleLink {\n    font-size: 1.2rem;\n  }\n\n  .snapshotSectionHead {\n    margin-bottom: 1rem;\n  }\n\n  .snapshotViewAll {\n    font-size: 0.85rem;\n  }\n\n  .snapshotList {\n    gap: 0.75rem;\n  }\n\n  .snapshotItem {\n    min-height: 0;\n    padding: 1rem;\n    gap: 0.85rem;\n    border-left: 3px solid var(--brand-orange);\n  }\n\n  .snapshotAvatar {\n    width: 52px;\n    height: 52px;\n  }\n\n  .snapshotItemTitle {\n    font-size: 1.05rem;\n    -webkit-line-clamp: 2;\n  }\n\n  .snapshotMeta {\n    font-size: 0.875rem;\n    color: #555;\n    word-break: break-word;\n  }\n\n  .snapshotBody {\n    gap: 0.45rem;\n  }\n\n  .snapshotTags {\n    gap: 0.45rem;\n    min-height: 0;\n  }\n\n  .tagChip {\n    font-size: 0.78rem;\n    padding: 0.3rem 0.65rem;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: unset;\n  }\n\n  .snapshotDate {\n    font-size: 0.8rem;\n    min-height: 0;\n  }\n\n  .snapshotAbout {\n    white-space: normal;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    font-size: 0.82rem;\n  }\n\n  .livePill,\n  .snapshotAction {\n    font-size: 0.72rem;\n  }\n\n  .livePill {\n    padding: 0.25rem 0.6rem;\n  }\n\n  .viewAllLink {\n    margin-top: 1.15rem;\n    padding: 0.35rem 0;\n    min-height: 44px;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  .instituteBox {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .academyCard {\n    gap: 1.25rem;\n    padding: 1.5rem 1.15rem;\n  }\n\n  .academyBtn {\n    width: 100%;\n    max-width: none;\n    padding: 0.9rem 1.25rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .snapshotGrid {\n    gap: 1.75rem;\n  }\n\n  .snapshotHeader {\n    flex-wrap: wrap;\n    align-items: center;\n  }\n}\n\n@media (max-width: 575px) {\n  .hero {\n    padding-top: 2rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .gatewayCard {\n    padding: 1.35rem;\n    min-height: auto;\n  }\n\n  .snapshotSection {\n    padding: 0.75rem 0.85rem 3rem;\n  }\n\n  .snapshotCard {\n    padding: 1rem;\n    border-radius: 14px;\n  }\n\n  .snapshotTitle,\n  .snapshotTitleLink {\n    font-size: 1.15rem;\n  }\n\n  .snapshotItem {\n    padding: 0.95rem 0.9rem;\n    border-radius: 10px;\n  }\n\n  .snapshotAvatar {\n    width: 48px;\n    height: 48px;\n  }\n\n  .snapshotItemTitle {\n    font-size: 1rem;\n  }\n\n  .snapshotMeta {\n    font-size: 0.84rem;\n  }\n\n  .tagChip {\n    font-size: 0.75rem;\n    padding: 0.28rem 0.58rem;\n  }\n\n  .metricsBanner {\n    padding: 1.75rem 1.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"landing": `HomeLanding_landing__tgean`,
	"nav": `HomeLanding_nav__GA+Ny`,
	"navScrolled": `HomeLanding_navScrolled__d9It0`,
	"navInner": `HomeLanding_navInner__MxwnF`,
	"navCenter": `HomeLanding_navCenter__gB0Bc`,
	"navActions": `HomeLanding_navActions__D-5Xo`,
	"logoLink": `HomeLanding_logoLink__1EOrJ`,
	"logo": `HomeLanding_logo__n61tY`,
	"navLinks": `HomeLanding_navLinks__J1NPw`,
	"navLink": `HomeLanding_navLink__TIp5F`,
	"navLinkActive": `HomeLanding_navLinkActive__L-Z2W`,
	"loginLink": `HomeLanding_loginLink__V-Jcs`,
	"getStartedBtn": `HomeLanding_getStartedBtn__GrJJT`,
	"employerLoginBtn": `HomeLanding_employerLoginBtn__WIHSt`,
	"menuToggle": `HomeLanding_menuToggle__srokT`,
	"mobileMenuOverlay": `HomeLanding_mobileMenuOverlay__ZLehi`,
	"mobileMenuBackdrop": `HomeLanding_mobileMenuBackdrop__nD+Yt`,
	"mobileMenuCard": `HomeLanding_mobileMenuCard__Zqboo`,
	"navMenuOpen": `HomeLanding_navMenuOpen__XBgIf`,
	"hero": `HomeLanding_hero__5ZFFf`,
	"heroTitle": `HomeLanding_heroTitle__kVLRr`,
	"heroTagline": `HomeLanding_heroTagline__eyyjF`,
	"gatewayGrid": `HomeLanding_gatewayGrid__Z0b4c`,
	"gatewayCard": `HomeLanding_gatewayCard__xkyFz`,
	"gatewayCardDark": `HomeLanding_gatewayCardDark__AiASJ`,
	"gatewayCardLight": `HomeLanding_gatewayCardLight__TtWRC`,
	"gatewayTitle": `HomeLanding_gatewayTitle__vrHm+`,
	"gatewayList": `HomeLanding_gatewayList__f9iEl`,
	"btnPrimary": `HomeLanding_btnPrimary__NJo0R`,
	"btnGhost": `HomeLanding_btnGhost__G5Fc8`,
	"jobBannersSection": `HomeLanding_jobBannersSection__fTUl4`,
	"jobBannersGrid": `HomeLanding_jobBannersGrid__kE1zF`,
	"jobBanner": `HomeLanding_jobBanner__M2Yrc`,
	"jobBannerBlue": `HomeLanding_jobBannerBlue__AaFNO`,
	"jobBannerOrange": `HomeLanding_jobBannerOrange__wZ7uf`,
	"jobBannerEyebrow": `HomeLanding_jobBannerEyebrow__FELpa`,
	"jobBannerTitle": `HomeLanding_jobBannerTitle__bR+b8`,
	"jobBannerSubtitle": `HomeLanding_jobBannerSubtitle__kkyx5`,
	"jobBannerBtnBlue": `HomeLanding_jobBannerBtnBlue__NJzQD`,
	"jobBannerBtnOrange": `HomeLanding_jobBannerBtnOrange__QbyWZ`,
	"snapshotSection": `HomeLanding_snapshotSection__RcakG`,
	"snapshotGrid": `HomeLanding_snapshotGrid__VAne5`,
	"snapshotCard": `HomeLanding_snapshotCard__ShVwc`,
	"snapshotTitle": `HomeLanding_snapshotTitle__f8wbd`,
	"snapshotSectionHead": `HomeLanding_snapshotSectionHead__wK2VU`,
	"snapshotViewAll": `HomeLanding_snapshotViewAll__hupfj`,
	"snapshotTitleLink": `HomeLanding_snapshotTitleLink__6ZtcB`,
	"snapshotList": `HomeLanding_snapshotList__flRBZ`,
	"snapshotItem": `HomeLanding_snapshotItem__u5h8g`,
	"snapshotAction": `HomeLanding_snapshotAction__BnXcZ`,
	"snapshotAvatar": `HomeLanding_snapshotAvatar__5JNWQ`,
	"snapshotBody": `HomeLanding_snapshotBody__ZbhV3`,
	"snapshotHeader": `HomeLanding_snapshotHeader__a3vxQ`,
	"snapshotHeaderActions": `HomeLanding_snapshotHeaderActions__BlisD`,
	"snapshotItemTitle": `HomeLanding_snapshotItemTitle__KPd6E`,
	"snapshotMeta": `HomeLanding_snapshotMeta__rC58v`,
	"snapshotTags": `HomeLanding_snapshotTags__moLBp`,
	"snapshotTagsSpacer": `HomeLanding_snapshotTagsSpacer__Rgo0d`,
	"snapshotDate": `HomeLanding_snapshotDate__RPADw`,
	"snapshotAbout": `HomeLanding_snapshotAbout__BT42v`,
	"livePill": `HomeLanding_livePill__exPGn`,
	"tagChip": `HomeLanding_tagChip__MB3Ic`,
	"viewAllLink": `HomeLanding_viewAllLink__uW2f-`,
	"emptyState": `HomeLanding_emptyState__4Tz0S`,
	"instituteRow": `HomeLanding_instituteRow__EJb0A`,
	"instituteBox": `HomeLanding_instituteBox__2NNca`,
	"instituteTitle": `HomeLanding_instituteTitle__P5oQL`,
	"instituteText": `HomeLanding_instituteText__yfyni`,
	"instituteLink": `HomeLanding_instituteLink__Vn6hg`,
	"academySection": `HomeLanding_academySection__tW2Ne`,
	"academyCard": `HomeLanding_academyCard__fh09I`,
	"academyText": `HomeLanding_academyText__a4T7t`,
	"academyBtn": `HomeLanding_academyBtn__NZpoW`,
	"metricsSection": `HomeLanding_metricsSection__1kMRH`,
	"metricsBanner": `HomeLanding_metricsBanner__LzqDH`,
	"metricValue": `HomeLanding_metricValue__yhsEy`,
	"metricText": `HomeLanding_metricText__cztDn`,
	"chatbotWrap": `HomeLanding_chatbotWrap__kT1dl`,
	"mobileBackdropIn": `HomeLanding_mobileBackdropIn__lwsaJ`,
	"mobileDrawerIn": `HomeLanding_mobileDrawerIn__RCCEH`,
	"mobileMenuWelcome": `HomeLanding_mobileMenuWelcome__pON6O`,
	"mobileMenuWelcomeTop": `HomeLanding_mobileMenuWelcomeTop__lkngV`,
	"mobileMenuLogoLink": `HomeLanding_mobileMenuLogoLink__KcvOR`,
	"mobileMenuLogo": `HomeLanding_mobileMenuLogo__Y2V+t`,
	"mobileMenuClose": `HomeLanding_mobileMenuClose__gfzX6`,
	"mobileMenuWelcomeTitle": `HomeLanding_mobileMenuWelcomeTitle__R623H`,
	"mobileMenuWelcomeSub": `HomeLanding_mobileMenuWelcomeSub__IUM6+`,
	"mobileMenuCtaRow": `HomeLanding_mobileMenuCtaRow__lYFxd`,
	"mobileMenuNav": `HomeLanding_mobileMenuNav__rdGtZ`,
	"mobileMenuLink": `HomeLanding_mobileMenuLink__JnR-e`,
	"mobileMenuLinkIcon": `HomeLanding_mobileMenuLinkIcon__MaAgE`,
	"mobileMenuLinkLabel": `HomeLanding_mobileMenuLinkLabel__mUxJ4`,
	"mobileMenuLinkChevron": `HomeLanding_mobileMenuLinkChevron__+Seaa`,
	"mobileMenuLinkActive": `HomeLanding_mobileMenuLinkActive__BhddF`,
	"mobileMenuLogin": `HomeLanding_mobileMenuLogin__U10l3`,
	"mobileMenuEmployerBtn": `HomeLanding_mobileMenuEmployerBtn__swfGV`,
	"mobilePanelIn": `HomeLanding_mobilePanelIn__vuL4y`
};
export default ___CSS_LOADER_EXPORT___;
